export default "__VITE_ASSET__DyFWUGQ8__"